import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type PermissionCodes =
  | 'SEE_SUCCESS_BANNER'
  | 'DOWNLOAD_PROOF_OF_COMPLETION'
  | 'ACCESS_CONGRATULATIONS_SCREEN'
  | 'ACCESS_JURY_SCREEN'
  | 'ACCESS_COACHING_SCREEN';

const useEndTrainingPermissions = getPermissionsHook<PermissionCodes>({
  entityName: 'end-of-training-permissions',
  fetch: ({ userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).endOfTrainingPermissions.get(),
});

export default useEndTrainingPermissions;
